// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__mrDXD","tab":"tabs_tab__n_Bin"};